export class DesktopPcmChunkAccumulator {
  private readonly sampleRate: number;
  private readonly chunkSizeSamples: number;
  private pendingChunks: Int16Array[] = [];
  private pendingOffset = 0;
  private pendingSamples = 0;
  private processedSamplesInternal = 0;

  constructor({ sampleRate, chunkDurationMs }: { sampleRate: number; chunkDurationMs: number }) {
    this.sampleRate = sampleRate;
    this.chunkSizeSamples = Math.max(1, Math.round((sampleRate * chunkDurationMs) / 1000));
  }

  push(samples: Int16Array): Int16Array[] {
    if (!samples.length) return [];
    this.pendingChunks.push(samples);
    this.pendingSamples += samples.length;

    const results: Int16Array[] = [];
    while (this.pendingSamples >= this.chunkSizeSamples) {
      const chunkSamples = this.extractSamples(this.chunkSizeSamples);
      this.processedSamplesInternal += chunkSamples.length;
      results.push(chunkSamples);
    }
    return results;
  }

  flush(): Int16Array | null {
    if (this.pendingSamples === 0) return null;
    const chunkSamples = this.extractSamples(this.pendingSamples);
    this.processedSamplesInternal += chunkSamples.length;
    return chunkSamples;
  }

  get processedSamples(): number {
    return this.processedSamplesInternal;
  }

  reset(): void {
    this.pendingChunks = [];
    this.pendingOffset = 0;
    this.pendingSamples = 0;
    this.processedSamplesInternal = 0;
  }

  private extractSamples(count: number): Int16Array {
    const result = new Int16Array(count);
    let written = 0;

    while (written < count && this.pendingChunks.length) {
      const current = this.pendingChunks[0];
      const available = current.length - this.pendingOffset;
      const toCopy = Math.min(available, count - written);
      result.set(current.subarray(this.pendingOffset, this.pendingOffset + toCopy), written);
      written += toCopy;
      this.pendingOffset += toCopy;

      if (this.pendingOffset >= current.length) {
        this.pendingChunks.shift();
        this.pendingOffset = 0;
      }
    }

    this.pendingSamples -= written;
    return result;
  }
}
